module.exports = __webpack_public_path__ + "static/img/ARAD_S4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD_S4.png
// module id = ONiy
// module chunks = 0